import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  sectionPaddings,
  standardColours,
  fluidFontSize,
  fontWeights,
  minBreakpointQuery,
} from '../styles';
import { Container, RichText, Video, Button } from './ui';

const StyledVideoContentBanner = styled.section`
  position: relative;
  background-color: ${standardColours.black};
`;

const StyledVideo = styled(Video)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  > div {
    height: 100%;
  }

  video {
    height: 100%;
    object-fit: cover;
  }
`;

const StyledOuter = styled.div`
  position: relative;
`;

const StyledContent = styled.div`
  ${sectionPaddings('70px', '140px')};
  max-width: 780px;
  color: ${standardColours.white};

  b {
    color: ${brandColours.secondary};
  }

  a {
    text-decoration: underline;
  }

  h2 {
    font-weight: ${fontWeights.medium};
    ${fluidFontSize(
      '40px',
      '60px',
      breakpointSizes.small,
      breakpointSizes.xxlarge,
    )};
    line-height: 1.1;
    white-space: break-spaces;
  }

  ul,
  ol {
    margin-top: 20px;

    li {
      margin: 6px 0 0 22px;
      ${fluidFontSize(
        '20px',
        '36px',
        breakpointSizes.tiny,
        breakpointSizes.xxlarge,
      )};
      line-height: 1.2;

      ${minBreakpointQuery.small`
        margin-left: 26px;
      `}

      ${minBreakpointQuery.large`
        margin-left: 30px;
      `}

      &:first-child {
        margin-top: 0;
      }
    }
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 0;

  ${minBreakpointQuery.tsmall`
     max-width: 400px;  
  `}
`;

const VideoContentBanner = ({ video, content, link }) => (
  <StyledVideoContentBanner>
    <StyledVideo data={video} autoPlay={true} controls={false} />
    <StyledOuter>
      <Container>
        <StyledContent>
          <RichText content={content} />
        </StyledContent>
      </Container>
      {link && (
        <StyledButton
          to={link.pageUrl}
          isAlt={true}
          isLarge={true}
          hasArrow={true}
        >
          {link.text}
        </StyledButton>
      )}
    </StyledOuter>
  </StyledVideoContentBanner>
);

export default VideoContentBanner;
